module.exports = __webpack_public_path__ + "static/img/SmileAnimation_mangopassionfruit.ce80cf9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_mangopassionfruit.gif
// module id = USg0
// module chunks = 0